import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_FILTER_OPTIONS } from '@/components/ActivityFeed/utils';

import { Filters } from '@/types/globalFilter';

interface PreferencesState {
  filters: Filters | null;
  userSettingsId: string | null;
  activityFeedFilters: string[];
}

const initialState: PreferencesState = {
  filters: null,
  userSettingsId: null,
  activityFeedFilters: Object.values(DEFAULT_FILTER_OPTIONS)
    .map((option) => option.map((filter) => (filter.checked ? filter.id : undefined)))
    .flat()
    .filter(Boolean) as string[]
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setFilters: (state, action: { payload: Filters }) => {
      state.filters = action.payload;
    },
    setUserSettingsId: (state, action: { payload: string }) => {
      state.userSettingsId = action.payload;
    },
    setActivityFeedFilters: (state, action: { payload: string[] }) => {
      state.activityFeedFilters = action.payload;
    },
    resetActivityFeedFilters: (state) => {
      state.activityFeedFilters = initialState.activityFeedFilters;
    }
  }
});

export const { setFilters, setUserSettingsId, setActivityFeedFilters, resetActivityFeedFilters } =
  preferencesSlice.actions;

export default preferencesSlice.reducer;
